import { useCallback } from 'react';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { requestAccess } from '../request-access.tsx';
import type { AccessRequestType } from './types.tsx';

const product = 'confluence';

export const useConfluenceRequestAccess = (integration = 'crossJoinNudgesConfluence') => {
	const cloudId = useCloudId();
	const userId = useAccountId() || '';
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useCallback(
		async (): Promise<AccessRequestType> =>
			requestAccess(product, cloudId, userId, integration, createAnalyticsEvent),
		[cloudId, userId, integration, createAnalyticsEvent],
	);
};
